/**
 * Format a timestamp as a human-readable relative time string.
 *
 * @param timestamp - Unix epoch in milliseconds
 * @param now - Optional current time in milliseconds (defaults to Date.now())
 */
export function formatRelative(timestamp: number, now?: number): string {
	const diff = Math.floor(((now ?? Date.now()) - timestamp) / 1000);
	if (diff < 60) return "just now";
	if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
	if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
	if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
	return new Date(timestamp).toLocaleDateString(undefined, {
		year: "numeric",
		month: "short",
		day: "numeric",
	});
}
